export const MES_REQUETES = "mes-requetes";
export const LISTE_REQUETE = "liste-requete";
export const ONGLET_DETAIL = "detail-requete";


export function toDetailRequete(numero) {
  return {
    name: ONGLET_DETAIL,
    params: { numero }
  }
}

export function toListeRequete() {
  return {
    name: LISTE_REQUETE,
  }
}
